import { Routes } from '@angular/router';
import { componentLabRoutes } from './pages/component-lab/routes';
import { HomePage } from './pages/home-page';
import { mechanicRoutes } from './pages/mechanics/routes';

export const routes: Routes = [
  {
    path: '',
    component: HomePage,
  },
  {
    path: 'component-lab',
    children: componentLabRoutes,
  },
  {
    path: 'mechanics',
    children: mechanicRoutes,
  },
];
